/* eslint-disable react/jsx-no-target-blank */
import { Image } from '@cian/ui-kit';
import { IconPlaceholderImage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './MainImage.css';
import { trackImageLinkClick } from './trackings';
import { IPageState } from '../../types/page';
import { IFavoriteEntity } from '../../types/results';
import { TUser } from '../../types/user';
import { PublicationRemovalNotice } from '../PublicationRemovalNotice';

export interface IMainImageStoreProps {
  page: IPageState;
  user: TUser;
  total: number;
  favoriteEntities: IFavoriteEntity[];
}

export interface IMainImageOwnProps {
  favoriteEntity: IFavoriteEntity;
}

export type TMainImage = IMainImageStoreProps & IMainImageOwnProps;

export function MainImage(props: TMainImage) {
  const {
    favoriteEntity: {
      fullUrl,
      photoPreviewUrl,
      photoFullUrl,
      status,
      deleteDate,
      entityId,
      isCianPartner,
      externalOfferUrl,
    },
    favoriteEntities,
    page,
    user,
    total,
  } = props;

  const href = isCianPartner ? (externalOfferUrl as string) : fullUrl;
  const hasImage = photoPreviewUrl || photoFullUrl;

  return (
    <div className={styles['container']}>
      <a
        href={href}
        target="_blank"
        onClick={() => {
          trackImageLinkClick(page, user, entityId, favoriteEntities, total);
        }}
      >
        {hasImage ? (
          <Image
            src={photoPreviewUrl || photoFullUrl || ''}
            width={262}
            height={226}
            alt="Главное фото объявления"
            objectFit="cover"
          />
        ) : (
          <div className={styles['empty_photo']}>
            <IconPlaceholderImage16 color="gray20_100" />
          </div>
        )}
      </a>
      <PublicationRemovalNotice status={status} deleteDate={deleteDate} />
    </div>
  );
}
